import React from 'react';

import { bemCssModules } from '@utils';

import useOverflowGap from './useOverflowGap';

import style from './OverflowCell.scss';

const cn = bemCssModules(style, 'OverflowCell');

export type TOverflowCell = {
  column: 1 | 2 | 3 | 4;
  error?: boolean;
};

const OverflowCell: CustomFC<TOverflowCell> = ({ className, children, column, error }) => {
  const [wrapperRef, ref, gap] = useOverflowGap();

  return (
    <div className={cn({ column }, [className])}>
      <div ref={wrapperRef} className={cn('wrapper', { overflow: !!gap, column, error })}>
        <div ref={ref} className={cn('content')} style={{ '--gap': -gap } as React.CSSProperties}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default OverflowCell;
